// extracted by mini-css-extract-plugin
export default {"empty":"TaskList_empty__x9iwZ"};